const GENERIC_MESSAGES = new Set([
  '400',
  'There were a validation errors',
  'validation_error',
  'Validation Failed'
])

function appendMessage(target, message) {
  if (typeof message !== 'string') {
    return
  }

  const normalizedMessage = message.trim()

  if (!normalizedMessage) {
    return
  }

  target.add(normalizedMessage)
}

function isGenericMessage(message) {
  return GENERIC_MESSAGES.has(message) || /^\d+$/.test(message)
}

function formatFieldMessage(fieldName, message, fieldLabels) {
  const label = fieldLabels[fieldName] || fieldName

  return `${label}: ${message}`
}

function normalizeFieldName(fieldName, fieldMap) {
  return fieldMap[fieldName] || fieldName
}

function collectMessages(value, target) {
  if (!value) {
    return
  }

  if (typeof value === 'string') {
    appendMessage(target, value)
    return
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectMessages(item, target))
    return
  }

  if (typeof value !== 'object') {
    return
  }

  const priorityKeys = ['message', 'errors', 'form', 'data', 'children']

  priorityKeys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      collectMessages(value[key], target)
    }
  })

  Object.keys(value).forEach((key) => {
    if (!priorityKeys.includes(key)) {
      collectMessages(value[key], target)
    }
  })
}

function collectFieldMessages(value, target, fieldLabels) {
  if (!value || typeof value !== 'object') {
    return
  }

  if (value.children && typeof value.children === 'object') {
    Object.keys(value.children).forEach((fieldName) => {
      const fieldValue = value.children[fieldName]
      const messages = new Set()

      collectMessages(fieldValue?.errors ?? fieldValue, messages)

      Array.from(messages)
        .filter((message) => !isGenericMessage(message))
        .forEach((message) => {
          target.add(formatFieldMessage(fieldName, message, fieldLabels))
        })
    })
  }

  Object.keys(value).forEach((key) => {
    collectFieldMessages(value[key], target, fieldLabels)
  })
}

export function extractApiFieldErrors(error, options = {}) {
  const source = error?.response?.data ?? error?.data ?? error
  const fieldMap = options.fieldMap || {}
  const result = {}

  function visit(value) {
    if (!value || typeof value !== 'object') {
      return
    }

    if (value.children && typeof value.children === 'object') {
      Object.keys(value.children).forEach((fieldName) => {
        const normalizedFieldName = normalizeFieldName(fieldName, fieldMap)
        const fieldValue = value.children[fieldName]
        const messages = new Set()

        collectMessages(fieldValue?.errors ?? fieldValue, messages)

        const filteredMessages = Array.from(messages).filter((message) => !isGenericMessage(message))

        if (filteredMessages.length) {
          result[normalizedFieldName] = filteredMessages
        }
      })
    }

    Object.keys(value).forEach((key) => {
      visit(value[key])
    })
  }

  visit(source)

  return result
}

export function extractApiErrorMessages(error, options = {}) {
  const source = error?.response?.data ?? error?.data ?? error
  const fieldLabels = options.fieldLabels || {}
  const fieldMessages = new Set()
  const messages = new Set()

  collectFieldMessages(source, fieldMessages, fieldLabels)
  collectMessages(source, messages)

  const collectedFieldMessages = Array.from(fieldMessages)

  if (collectedFieldMessages.length) {
    return collectedFieldMessages
  }

  const collectedMessages = Array.from(messages)
  const filteredMessages = collectedMessages.filter((message) => !isGenericMessage(message))

  return filteredMessages.length ? filteredMessages : collectedMessages
}
